/*
 * Native Social Proof — rotate each widget's qualifying messages one at a time (fade).
 * A single message shows statically. Handles multiple instances (e.g. one per cart line
 * item) and cart-drawer re-renders via a MutationObserver. Replaces ConvertCart.
 */
(function () {
  'use strict';
  if (window.__aroSpBooted) return; // guard against the script tag appearing more than once
  window.__aroSpBooted = true;

  function initOne(el) {
    if (el.__aroSpInit) return; // already wired
    el.__aroSpInit = true;
    var items = el.querySelectorAll('.aro-sp__item');
    if (items.length <= 1) return; // one message → static, no rotation
    el.classList.add('is-rotating');
    var i = 0;
    items[0].classList.add('is-active');
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3500);
  }

  function initAll() {
    var nodes = document.querySelectorAll('.aro-sp');
    for (var k = 0; k < nodes.length; k++) initOne(nodes[k]);
  }

  initAll();

  // The cart drawer injects/replaces line items dynamically — wire any new widgets as they appear.
  if (window.MutationObserver) {
    new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
  }
})();
